import { type FC } from 'react';
import { type EwayAccessCode } from '@/api/registration/payment';
import { useRegisterSteps } from '@/registration/hook/useRegisterSteps';
import EwayPaymentIframe from '@/registration/component/Register/Payment/PayByEWayIframe';

export interface PayByEWayProps {
  setErrors: React.Dispatch<React.SetStateAction<string[]>>
  options: EwayAccessCode
  isValid: boolean
}

const PayByEWay: FC<PayByEWayProps> = ({
  setErrors,
  options,
  isValid
}) => {
  const { toPaymentProcessingStep } = useRegisterSteps();

  const resultCallback = async (result: string, transactionID: string, errors: string) => {
    if (errors) {
      setErrors([errors]);
    } else if (result === 'Complete') {
      // Whether a transaction was processed. One of Complete, Cancel, or Error
      const additionalParams = { orderHash: options.order.secureHash };
      toPaymentProcessingStep(additionalParams);
    }
  };

  return (
    <EwayPaymentIframe
      isLoading={false}
      isDisabled={!isValid}
      sharedPaymentUrl={options.accessCodesShared}
      resultCallback={resultCallback}
    />
  );
};

export default PayByEWay;
